export default "__VITE_ASSET__B6RFOFXB__"